export default __webpack_public_path__ + "static/cms-84bc37f265d5e84db8f89648b0f0231d.png";